import ctxsNative from '../ctxsNative';
import { Logger } from '../Logger';
import { logConstants } from '../../utils/Constants';
import { v4 as uuidv4 } from 'uuid';

export const NativeCallbackQueue: {
	callbackId: string;
	resolve: Function;
	reject: Function;
}[] = [];

window.fetchComplete = async function (
	callbackId: string,
	response: string
): Promise<void> {
	Logger.getInstance().write(logConstants.INFO, 'fetchComplete called');
	const firstReqIndex = NativeCallbackQueue.findIndex(
		(req) => req.callbackId === callbackId
	);
	if (firstReqIndex !== -1) {
		NativeCallbackQueue[firstReqIndex].resolve(response);
	} else {
		Logger.getInstance().write(
			logConstants.ERROR,
			'fetchComplete could not able to retrieve content'
		);
	}
};

window.getCredentialsComplete = async function (
	callbackId: string,
	response: string
): Promise<void> {
	Logger.getInstance().write(logConstants.INFO, 'getCredentialsComplete called');
	const firstReqIndex = NativeCallbackQueue.findIndex(
		(req) => req.callbackId === callbackId
	);
	if (firstReqIndex !== -1) {
		NativeCallbackQueue[firstReqIndex].resolve(response);
	} else {
		Logger.getInstance().write(
			logConstants.ERROR,
			'getCredentialsComplete could not able to retrieve content'
		);
	}
};

window.isIWAEnabledComplete = async function (
	callbackId: string,
	resultJSON: string
): Promise<void> {
	Logger.getInstance().write(
		logConstants.INFO,
		'isIWAEnabledComplete called with params'
	);
	const firstReqIndex = NativeCallbackQueue.findIndex(
		(req) => req.callbackId === callbackId
	);
	if (firstReqIndex !== -1) {
		NativeCallbackQueue[firstReqIndex].resolve(resultJSON);
	} else {
		Logger.getInstance().write(
			logConstants.ERROR,
			'isIWAEnabledComplete could not able to retrieve content'
		);
	}
};

window.getSsoCredentialsComplete = async function (
	callbackId: string,
	response: string
): Promise<void> {
	Logger.getInstance().write(logConstants.INFO, 'getSsoCredentialsComplete called');
	const firstReqIndex = NativeCallbackQueue.findIndex(
		(req) => req.callbackId === callbackId
	);
	if (firstReqIndex !== -1) {
		NativeCallbackQueue[firstReqIndex].resolve(response);
	} else {
		Logger.getInstance().write(
			logConstants.ERROR,
			`getSsoCredentialsComplete could not find ${callbackId} in callback queue`
		);
	}
};

const NativeBridgeWrapper = {
	async fetch(requestDetails: string): Promise<string> {
		const callbackId = uuidv4();
		return new Promise(
			function (resolve: Function, reject: Function): void {
				NativeCallbackQueue.push({
					callbackId: callbackId,
					resolve: resolve,
					reject: reject,
				});
				ctxsNative.fetchWithCallback(callbackId, requestDetails);
			}.bind(this)
		);
	},

	async getCredentials(requestDetails: string): Promise<string> {
		const callbackId = uuidv4();
		return new Promise(
			function (resolve: Function, reject: Function): void {
				NativeCallbackQueue.push({
					callbackId: callbackId,
					resolve: resolve,
					reject: reject,
				});
				ctxsNative.getCredentials(callbackId, requestDetails);
			}.bind(this)
		);
	},

	async isIWAEnabled(jsonStr: string): Promise<string> {
		const callbackId = uuidv4();
		return new Promise(
			function (resolve: Function, reject: Function): void {
				NativeCallbackQueue.push({
					callbackId: callbackId,
					resolve: resolve,
					reject: reject,
				});
				ctxsNative.isIWAEnabled(callbackId, jsonStr);
			}.bind(this)
		);
	},

	async getSsoCredentials(jsonStr: string): Promise<string> {
		const callbackId = uuidv4();
		return new Promise(
			function (resolve: Function, reject: Function): void {
				NativeCallbackQueue.push({
					callbackId: callbackId,
					resolve: resolve,
					reject: reject,
				});
				ctxsNative.getSsoCredentials(callbackId, jsonStr);
			}.bind(this)
		);
	},
};
export default NativeBridgeWrapper;
